<template>
  <Table :columns="columns" :data="list">
    <template slot-scope="{ row }" slot="image">
      <Avatar shape="square" :src="row.image | url" :size="30" />
    </template>
    <template slot-scope="{ row }" slot="action">
      <a @click="$emit('update', row)">{{ $t('name.update') }}</a>
    </template>
  </Table>
</template>
<script>
export default {
  props: {
    list: Array,
  },
  data() {
    return {
      columns: [
        {
          title: "ID",
          key: "id",
        },
        {
          title: this.$t("name.template.image"),
          slot: "image",
        },
        {
          title: this.$t("name.template.keyword"),
          key: "keyword",
        },
        {
          title: this.$t("name.template.name"),
          key: "name",
        },
        {
          title: this.$t("name.template.version"),
          key: "version",
        },
        {
          title: this.$t("name.template.sort"),
          key: "sort",
        },
        {
          title: this.$t("name.active"),
          slot: 'action',
        },
      ],
    };
  },
};
</script>